export default __webpack_public_path__ + "static/media/AM_00803 copy.7e1b7ede.jpg";